import { render, staticRenderFns } from "./OutpatientRegist.vue?vue&type=template&id=2528a57c&scoped=true"
import script from "./OutpatientRegist.vue?vue&type=script&lang=js"
export * from "./OutpatientRegist.vue?vue&type=script&lang=js"
import style0 from "./OutpatientRegist.vue?vue&type=style&index=0&id=2528a57c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2528a57c",
  null
  
)

export default component.exports